import { validateEmail } from "helpers/email";
import {
	CNPJValidation,
	CPFValidation,
	dateValidation
} from "helpers/validators";

const validate = (values, step) => {
	const errors = {};

	// if (step === 1) {
	// }

	if (step === 2) {
		if (!values.name) {
			errors["name"] = "Informe seu nome";
		}

		if (!values.lastname) {
			errors["lastname"] = "Informe seu sobrenome";
		}

		if (!values.email) {
			errors["email"] = "Informe seu e-mail";
		} else if (!validateEmail(String(values["email"]))) {
			errors["email"] = "Informe um e-mail válido";
		}

		if (!values.cpf) {
			errors["cpf"] = "Informe seu cpf";
		} else if (!CPFValidation(String(values["cpf"]))) {
			errors["cpf"] = "Informe um cpf válido";
		}

		if (!values.birthDate) {
			errors["birthDate"] = "Informe sua data de nascimento";
		} 
		// else if (!dateValidation(values["birthDate"], "DD/MM/YYYY")) {
		// 	errors["birthDate"] = "Informe uma data de nascimento válida";
		// }

		if (!values.birthPlace) {
			errors["birthPlace"] = "Informe sua cidade de nascimento";
		}

		if (
			values.type === "coordinator" &&
			(values.region || values.local || values.provincial)
		) {
			if (values.local && !values.companyNameLocal) {
				errors["companyNameLocal"] = "Informe o nome da local";
			}

			if (values.local && !values.professionLocal) {
				errors["professionLocal"] = "Informe o cargo na local";
			}

			if (values.region && !values.companyNameRegion) {
				errors["companyNameRegion"] = "Informe o nome da regional";
			}

			if (values.region && !values.professionRegion) {
				errors["professionRegion"] = "Informe o cargo na regional";
			}

			if (values.provincial && !values.companyNameProvincial) {
				errors["companyNameProvincial"] = "Informe o nome da estadual";
			}

			if (values.provincial && !values.professionProvincial) {
				errors["professionProvincial"] = "Informe o cargo na estadual";
			}
		}

		if (values.type === "director" && (values.feapaes || values.apae)) {
			if (!values.profession) {
				errors["profession"] = "Informe seu cargo na FEAPAES ou APAE";
			}
		}

		if (values.type === "exhibitor") {
			if (!values.companyName) {
				errors["companyName"] = "Informe o nome da empresa";
			}

			if (!values.cnpj) {
				errors["cnpj"] = "Informe o CNPJ da empresa";
			} else if (!CNPJValidation(String(values["cnpj"]))) {
				errors["cnpj"] = "Informe um CNPJ válido";
			}
		}

		// if (values.type === "professional") {
		// 	if (!values.architect && !values.interiorDecorator) {
		// 		errors["architect"] = "Informe sua profissão";
		// 	}
		// }
	}

	if (step === 3) {
		if (!values.city) {
			errors["city"] = "Informe sua cidade";
		}

		if (!values.state) {
			errors["state"] = "Informe seu estado";
		}
		// if (!values.gender) {
		// 	errors["gender"] = "Informe seu gênero";
		// }
	}

	console.log(errors);
	return errors;
};

export default validate;
